import React from 'react';

const GenericCard = ({ title, subtitle, optionsMenu, statusTag = null, additionalFields = [] }) => {
  return (
    <div
      className=" rounded-lg bg-white p-4 flex flex-col relative h-full"
      style={{ boxShadow: '0px 6px 26px #626B7D12' }}
    >
      <div>
        <div className="text-[18px] font-semibold text-[#38485C] opacity-100">
          {title || ''}
        </div>
        {subtitle && (
          <div className="text-[14px] font-semibold text-[#6B78F8] opacity-100">
            {subtitle || ''}
          </div>
        )}

        {additionalFields.length > 0 && (
          <div className="mt-4 space-y-1">
            {additionalFields.map((field, index) => (
              <div key={field.id || field.label || index} className="text-[12px] text-[#919191]">
                <span className="font-medium">{field.label}:</span> {field.value}
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="flex-grow"></div>

      {statusTag && (
        <div className="mt-auto">
          {statusTag}
        </div>
      )}

      {optionsMenu && (
        <div className="absolute bottom-2 right-2">{optionsMenu}</div>
      )}
    </div>
  );
};

export default GenericCard;
